module.exports = __webpack_public_path__ + "img/1496504385.4dfef09f.jpg";